import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Get ring details for a PO (aggregated by ring_unique_name)
 * @param {number|string} poId - PO record id from verify-po response
 * @returns {Promise<{ success: boolean, data?: array, error?: string }>}
 */
export const getPoRingsDetail = async (poId) => {
  try {
    const response = await apiClient.get(`/vendorInvoiceManagement/invoice/rings-detail/${poId}`);
    const data = response.data?.response ?? response.data;
    const list = Array.isArray(data) ? data : [];
    return { success: true, data: list };
  } catch (error) {
    handleApiError(error);
    return {
      success: false,
      data: [],
      error: error.response?.data?.message || error.message,
    };
  }
};
